import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03388574"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-table-header" }
const _hoisted_2 = { class: "grid-table-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridHeaderCell = _resolveComponent("GridHeaderCell")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cellDatas, (item) => {
          return (_openBlock(), _createBlock(_component_GridHeaderCell, {
            key: item.initials,
            compsData: this.compsData,
            cellData: item,
            sEDetails: this.sEDetails,
            hasMLSData: this.hasMLSData,
            emptySourceData: this.emptySourceData,
            isSubject: this.isSubject,
            subjectCascadeDisabled: this.subjectCascadeDisabled
          }, null, 8, ["compsData", "cellData", "sEDetails", "hasMLSData", "emptySourceData", "isSubject", "subjectCascadeDisabled"]))
        }), 128))
      ])
    ]),
    (_ctx.modalDataSources.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalDataSources.component), {
          key: 0,
          sources: _ctx.modalDataSources.sources,
          onHide: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalDataSources.show = false))
        }, null, 8, ["sources"]))
      : _createCommentVNode("", true),
    (_ctx.modalMapView.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalMapView.component), {
          key: 1,
          details: _ctx.modalMapView.details,
          onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalMapView.show = false))
        }, null, 8, ["details"]))
      : _createCommentVNode("", true),
    (_ctx.modalAdditionalFields.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalAdditionalFields.component), {
          key: 2,
          onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalAdditionalFields.show = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.modalSaleHistory.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalSaleHistory.component), {
          key: 3,
          onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalSaleHistory.show = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}